import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	height: 40px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex-grow: 1;
	padding-right: 20px;
`;

const StyledSliderBackgroundWrapper = styled.div`
	position: relative;
	display: flex;
	width: 480px;
	padding-left: 20px;
`;

const StyledBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: -1;
	width: 330px;
	height: 40px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-right: none;
	border-radius: 10px 0 0 10px;
`;

const StyledBlueBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 40px;
	background-color: #2d70da;
	opacity: 0.25;
	border-radius: 10px 0 0 10px;
`;

const StyledSliderContainer = styled.div`
	position: relative;
	height: 20px;
	display: flex;
	align-items: center;

	> div {
		width: 30px;
		height: 5px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		background-color: #2d70da;
	}

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		width: 100%;
		height: 1px;
		transform: translateY(-50%);
		background-color: #fff;
		opacity: 0.1;
		pointer-events: none;
	}
`;

const StyledSlider = styled.input.attrs({
	type: 'range',
	step: 1,
	defaultValue: 0,
})`
	appearance: none;
	width: 100%;
	margin: 0;
	background: transparent;
	cursor: pointer;

	&:focus {
		outline: 0;
	}

	&::-webkit-slider-runnable-track {
		height: 5px;
	}

	&::-webkit-slider-thumb {
		appearance: none;
		margin-top: -3px;
		margin-left: -1px;
		width: 11px;
		height: 11px;
		border-radius: 10px;
		background-color: #fff;
		background-clip: content-box;
	}
`;

const StyledBottomCaption = styled.div`
	display: flex;
	justify-content: space-between;

	> span {
		font-family: 'GT Walsheim Pro';
		font-size: 12px;
		line-height: 14px;
		color: #fff;
		opacity: 0.25;
	}
`;

const StyledMaxButton = styled.button`
	width: 60px;
	height: 40px;
	background-color: #2d70da;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	border: none;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledValueContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 90px;
	height: 40px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-left: none;
	border-radius: 0 10px 10px 0;

	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	user-select: none;
	pointer-events: none;
`;

export {
	StyledBackground,
	StyledBlueBg,
	StyledBottomCaption,
	StyledContainer,
	StyledMaxButton,
	StyledSlider,
	StyledSliderBackgroundWrapper,
	StyledSliderContainer,
	StyledValueContainer,
};
